export default __webpack_public_path__ + "static/media/mcaccess2.7066f788.png";